<template>
  <div tabindex="0" class="font-inter">
    <router-view />
  </div>
</template>

<style lang="scss">
// TODO: Remove this once we have updated all font awesome icons to lucide
@use '@/styling/setup.scss';
@use '@/styling/peach.css';
@use '@/styling/tel-input.scss';
@use '@/styling/otp-input.scss';
@use '@/styling/layup-spinner.css';
</style>

<script setup lang="ts">
import { setupFreshchat, type IFreshchatConfig } from '@/utils/freshchat.utils';
import { createException } from '@/utils/monitoring.utils';
import { onMounted } from 'vue';

onMounted(() => {
  const config: IFreshchatConfig = {
    token: 'a142ad56-f318-45ac-960d-da9b316f5c09',
    host: 'https://wchat.freshchat.com',
    siteId: 'Customer',
  };

  setupFreshchat(config).catch((error) => {
    if (error instanceof Error) {
      createException(error);
    } else {
      createException(new Error('Failed to load Freshchat script'), {
        extra: {
          error,
        },
      });
    }
  });
});
</script>
